import React, { useEffect, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useHistory, useLocation } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import { notificationFilterById } from "../../../../../actions/Utilities/NotificationFilter";
import AddButton from "../../../../../components/AddButton";
import CancelButton from "../../../../../components/CancelButton";
import ConfirmBoxDelete from "../../../../../components/ConfirmBoxDelete";
import ConfirmBoxModal from "../../../../../components/ConfirmBoxModal";
import EditButton from "../../../../../components/EditButton";
import SaveButton from "../../../../../components/SaveButton";
import MaterialTableTS from "../../../../../components/tables/MaterialTableTS";
import TextInput from "../../../../../components/TextInput";
import { toast } from "../../../../../components/toastNotification";
import { permissionsSelector } from "../../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../../PermissionsConstants";
import TableFilters from "../../TableFilters";
import {
  addStateDept,
  editStateDepartment,
  selectedRowsStateDept,
  savingDepartment,
  rowForEditDepartment,
  editRowDepartmentId,
} from "./../atoms/atoms";
import useGetOfficeDepartment from "./../hooks/useGetOfficeDepartment";
import OfficeDepartmentForm from "../form/OfficeDepartmentForm";
import { deleteOfficeDepartment } from "../../../../../actions/Utilities/OfficeDepartment";
import useEditOfficeDepartment from "../hooks/useEditOfficeDepartment";
import { IOfficeDepartmentDetails } from "../types";

export const OfficeDepartmentTable: React.FC = () => {
  const userPermissions = useRecoilValue(permissionsSelector);
  const addPermission =
    PERMISSIONS.permission_utilities_officeconfiguration_officedepartment_add;
  const deletePermission =
    PERMISSIONS.permission_utilities_officeconfiguration_officedepartment_delete;
  const editPermission =
    PERMISSIONS.permission_utilities_officeconfiguration_officedepartment_edit;

  const [departmentList, setDepartmentList] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [departmentFilteredData, setdepartmentFilteredData] = useState([]);
  const [actionAddState, setActionAddState] = useRecoilState(addStateDept);
  const queryClient = useQueryClient();
  const [rowsCount, setRowsCount] = useState(0);
  const [selectedRows, setSelectedRows] = useRecoilState(selectedRowsStateDept);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [edit, setEdit] = useState(false);
  const [actionEditState, setActionEditState] =
    useRecoilState(editStateDepartment);
  const [editRowId, setEditRowId] = useRecoilState(editRowDepartmentId);
  const [hideColumn, sethideColumn] = useState(false);
  const [rowToEdit, setRowToEdit] = useRecoilState(rowForEditDepartment);
  const [checkStatus, setCheckStatus] = useState(false);
  const [dataIsChanged, setDataIsChanged] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [disabledButton, setDisabledButton] = useState(false);
  const [newData, setNewData] = useState<IOfficeDepartmentDetails>();
  const [isSaving, setIsSaving] = useRecoilState(savingDepartment);
  const [hasDepartment, setHasDepartment] = useState(true);

  const {
    data: departmentData,
    isLoading: isFetching,
    isSuccess: departmentSuccess,
  } = useGetOfficeDepartment();
  useEffect(() => {
    if (departmentSuccess && departmentData) {
      if (departmentData?.status === 200) {
        setDepartmentList(departmentData?.data.map((data) => ({ ...data })));
      } else {
        toast.fire("Server Error", "Cannot retrieve Make Data", "error");
      }
      setDepartmentList([]);
    }
  }, [departmentData, departmentSuccess]);

  let location = useLocation();
  const history = useHistory();
  let recordIdFromRecent;

  if (location.state == null) {
    //Do nothing
  } else {
    recordIdFromRecent = location.state;
  }

  useEffect(() => {
    if (recordIdFromRecent) {
      try {
        notificationFilterById(
          recordIdFromRecent.recordId,
          recordIdFromRecent.moduleName,
          recordIdFromRecent.subModuleName
        ).then((result) => {
          setdepartmentFilteredData(result);
          setDeptId(recordIdFromRecent.recordId);
        });
      } catch (error) {}
    } else {
      localStorage.removeItem("NotifFilter");
      localStorage.removeItem("ModuleFilter");
    }
  }, [history, recordIdFromRecent]);

  //For filtered data update
  const [deptId, setDeptId] = useState("");
  useEffect(() => {
    if (deptId?.includes(".")) {
      let deptIds = deptId.split(".");
      const deptIdsArr = deptIds.map((id) => Number(id));
      const filteredData = departmentData?.data?.filter((x) =>
        deptIdsArr.includes(x.officeDepartmentId)
      );
      setdepartmentFilteredData(filteredData);
    } else {
      const filteredData = departmentData?.data?.filter(
        (x) => x.officeDepartmentId === Number(deptId)
      );
      setdepartmentFilteredData(filteredData);
    }
  }, [deptId, departmentData?.data]);

  useEffect(() => {
    if (filterText) {
      setDepartmentList(
        departmentData?.data.filter((x) =>
          x.officeDepartmentName
            ?.toLowerCase()
            .includes(filterText?.trim().toLowerCase())
        )
      );
    } else {
      setDepartmentList(departmentData?.data);
    }
  }, [filterText, departmentData?.data]);

  // Deactivate
  const handleDelete = () => {
    const ids = selectedRows.map((row) => row.officeDepartmentId);
    setSelectedRows([]);
    setOpenModalDelete(false);
    deactOfficeDepartment.mutate(ids);
  };

  const handleSelectedRowsChange = (rows) => {
    const forDelete = rows
      .filter((x) => x.isActive)
      .map((r) => {
        const { tableData, ...rows } = r;
        return rows;
      });
    setSelectedRows(forDelete);
    setRowsCount(forDelete.length);
  };

  // Edit
  const {
    mutate: editOfficeDepartment,
    isSuccess: editSuccess,
    isError: editError,
    data: editResult,
    reset: resetEditData,
  } = useEditOfficeDepartment();

  useEffect(() => {
    setDataIsChanged(false);
    setActionAddState(false);
    setActionEditState(false);
    setSelectedRows([]);
    setEditRowId([]);
  }, []);

  const handleEdit = (rowDetails) => {
    setRowToEdit({ ...rowDetails, isActive: rowDetails.isActive });
    setActionEditState(true);
    sethideColumn(true);
    setDataIsChanged(false);
    setCheckStatus(rowDetails.isActive);
    setEditRowId(rowDetails.officeDepartmentId);
  };

  const handleEditFieldsChange = (inputvalue) => {
    setDataIsChanged(false);
    inputvalue = inputvalue.trim();

    newData!.officeDepartmentName = inputvalue;
    setDataIsChanged(true);
    if (newData?.officeDepartmentName.length === 0) {
      setHasDepartment(false);
    } else {
      setHasDepartment(true);
    }
  };

  const handleCheckBox = (e) => {
    const checked = e.target.checked;
    setDataIsChanged(true);
    checked ? setCheckStatus(true) : setCheckStatus(false);
    newData!.isActive = checked;
    if (newData?.officeDepartmentName.length === 0) {
      setDataIsChanged(false);
    }
  };

  //Save changes
  const handleSave = (newData) => {
    if (
      rowToEdit?.officeDepartmentName === newData?.officeDepartmentName &&
      rowToEdit?.isActive === newData?.isActive
    ) {
      setIsSaving(false);
      toast.fire("Saving Failed", "No Changes have been made", "warning");
      queryClient.invalidateQueries();
      setOpenModalEdit(false);
    } else {
      editOfficeDepartment(newData);
      setEditRowId([]);
      setSelectedRows([]);
      setDataIsChanged(false);
      setOpenModalEdit(false);
      setActionEditState(false);
      setDisabledButton(false);
      setEdit(false);
      sethideColumn(false);
    }
  };

  const handleCancel = () => {
    setActionEditState(false);
    setRowToEdit(undefined);
    setEditRowId([]);
    setDataIsChanged(false);
    setDisabledButton(false);
    setEdit(false);
    sethideColumn(false);
    setHasDepartment(true);
    queryClient.invalidateQueries();
  };

  const alignCenter = "center" as
    | "center"
    | "inherit"
    | "justify"
    | "left"
    | "right"
    | undefined;

  const matColumns = [
    {
      title: "Office Department Name",
      field: "officeDepartmentName",
      customSort: (a, b) =>
        a.officeDepartmentName && b.officeDepartmentName
          ? a.officeDepartmentName
              .trim()
              .localeCompare(b.officeDepartmentName.trim())
          : a.officeDepartmentName
          ? 0
          : -1,
      render: (rowData) => {
        return rowData.officeDepartmentId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer">
            <TextInput
              placeholder="Office Department"
              defaultValue={rowData.officeDepartmentName}
              onChange={(inputdata) => {
                handleEditFieldsChange(inputdata.target.value);
              }}
              value={undefined}
            />
          </div>
        ) : (
          <span>{rowData.officeDepartmentName}</span>
        );
      },
    },
    {
      title: "Created By",
      field: "createdBy",
      hidden: hideColumn,
      render: (rowData) => {
        return rowData.officeDepartmentId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : (
          <>{rowData.createdBy}</>
        );
      },
    },
    {
      title: "Created Date",
      field: "createdDate",
      hidden: hideColumn,
      render: (rowData) => {
        return rowData.officeDepartmentId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : (
          <>
            {rowData?.createdDate
              ? new Date(rowData.createdDate).toLocaleDateString()
              : ""}
          </>
        );
      },
    },
    {
      title: "Modified By",
      field: "modifiedBy",
      hidden: hideColumn,
      render: (rowData) => {
        return rowData.officeDepartmentId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : (
          <>{rowData.modifiedBy}</>
        );
      },
    },
    {
      title: "Modified Date",
      field: "modifiedDate",
      hidden: hideColumn,
      render: (rowData) => {
        return rowData.officeDepartmentId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : (
          <>
            {rowData?.modifiedDate
              ? new Date(rowData.modifiedDate).toLocaleDateString()
              : ""}
          </>
        );
      },
    },
    {
      title: "Status",
      field: "isActive",
      render: (rowData) => {
        return rowData.officeDepartmentId === editRowId ? (
          <div className="flex space-x-1 cursor-pointer">
            <input
              type="checkbox"
              className="flex items-center space-x-1 cursor-pointer mt-0.5"
              defaultChecked={rowData.isActive}
              onClick={(e) => {
                handleCheckBox(e);
              }}
            />
            <label className="items-center cursor-pointer text-green-600 text-xs">
              {checkStatus ? "Uncheck to Deactivate" : "Check to Activate"}
            </label>
          </div>
        ) : (
          <div className="font-sans text-left mr-4 text-xs">
            {rowData.isActive ? "Active" : "Inactive"}
          </div>
        );
      },
    },
    {
      title: "Action/s",
      align: alignCenter,
      render: (rowData) => {
        return !userPermissions.includes(editPermission) ? (
          ""
        ) : rowData.officeDepartmentId === editRowId ? (
          <div className="flex items-center place-content-center space-x-2 w-full mr-2">
            <SaveButton
              className={`flex items-center shadow-md text-xs font-semibold text-white  gap-x-1 rounded-full  bg-senary hover:bg-senary px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70
              ${
                !hasDepartment || !dataIsChanged ? "opacity-50" : "opactiy-100"
              }`}
              disabled={!hasDepartment || !dataIsChanged}
              onClick={() => {
                setOpenModalEdit(true);
              }}
            />
            <CancelButton
              onClick={(event) => {
                event.preventDefault();
                handleCancel();
              }}
            />
          </div>
        ) : (
          <div className="flex items-center place-content-center mr-5">
            <EditButton
              disabled={disabledButton || selectedRows.length > 0}
              className={
                disabledButton || selectedRows.length > 0
                  ? "opacity-50 rounded-full items-center bg-quaternary  text-white hover:bg-hquaternary "
                  : "opacity-100 rounded-full items-center bg-quaternary  text-white hover:bg-hquaternary"
              }
              onClick={() => {
                setDisabledButton(true);
                setActionEditState(true);
                handleEdit(rowData);
                setNewData(rowData);
              }}
            />
          </div>
        );
      },
    },
  ];

  //Deactivate Toast
  const deactOfficeDepartment = useMutation(
    (ids: number[] | undefined) => deleteOfficeDepartment(ids),
    {
      onSuccess: () => {
        queryClient.invalidateQueries();
        toast.fire(
          "Success",
          "Office Department were deactivated successfully",
          "success"
        );
      },
      onError: () => {
        toast.fire(
          "Bulk deactivation of Office Department failed",
          "Server Error: Cannot deactivate Office Department",
          "error"
        );
      },
    }
  );
  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${rowsCount} ${
      rowsCount > 1 ? "Office Departments" : "Office Department"
    }?`}</div>
  );

  // Edit Result
  if (editSuccess && editResult) {
    if (
      (editResult && editResult.status === 400) ||
      editResult.data === "Duplicate"
    ) {
      toast.fire("Failed", "Office Department Already Exists.", "error");
      queryClient.invalidateQueries();
      setIsSaving(!isSaving);
    } else if (
      (editResult && editResult.status === 201) ||
      editResult.status === 200
    ) {
      toast.fire(
        "Success",
        "Office Department Updated Successfully.",
        "success"
      );
      queryClient.invalidateQueries();
      handleCancel();
      setRowToEdit(undefined);
      setActionEditState(false);
    } else if (editResult.status === 500) {
      if (
        editResult.data.message ===
          "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available" ||
        editResult.data.message ===
          "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available"
      ) {
        toast.fire(
          "Warning",
          "New Office Department updated successfully, but " +
            editResult.data.message,
          "warning"
        );
        setIsSaving(false);
        handleCancel();
        setRowToEdit(undefined);
      } else {
        setIsSaving(false);
        setRowToEdit(undefined);
        toast.fire(
          "Failed",
          "Failed to Update Office Department! No Data Saved",
          "error"
        );
      }
      queryClient.invalidateQueries();
      setActionEditState(false);
    }
    resetEditData();
  }
  if (editError) {
    setIsSaving(false);
    toast.fire(
      "Server Error",
      "Failed to Update Office Department! No Data Saved",
      "error"
    );
    queryClient.invalidateQueries();
    setActionEditState(false);
  }
  return (
    <div className="animate-fade-in-down bg-white p-4">
      <div className="">
        {!actionAddState && (
          <div className="">
            <div className="flex w-full">
              <div className="bg-white w-full">
                <div className="font-bold text-primary text-xl uppercase mx-4">
                  {" "}
                </div>
                <div className="flex justify-between text-xs items-center w-full">
                  <div className="">
                    <TableFilters
                      moduleDetails={"Office Department Name"}
                      textInputName={"OfficeDepartmentName"}
                      filterText={setFilterText}
                      disabledButton={
                        actionEditState ||
                        (selectedRows !== undefined && selectedRows.length > 0)
                      }
                    />
                  </div>
                  <div className="">
                    {userPermissions.includes(addPermission) ? (
                      <AddButton
                        buttonText="New Office Department"
                        onClick={() => setActionAddState(true)}
                        disabled={
                          actionEditState ||
                          (selectedRows !== undefined &&
                            selectedRows.length > 0)
                        }
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div>
                  {userPermissions.includes(deletePermission) ? (
                    <div className="text-secondary italic text-xs3 my-2">
                      <p className="font-bold italic inline-block mr-1">
                        Note:
                      </p>
                      <span>Tick the box to deactivate some data.</span>
                    </div>
                  ) : (
                    <div className="mb-4"></div>
                  )}
                </div>
                <div className="">
                  <MaterialTableTS
                    data={
                      departmentFilteredData?.length > 0
                        ? departmentFilteredData
                        : departmentList
                    }
                    showTitle={true}
                    columns={matColumns}
                    isLoading={isFetching}
                    onSelectionChange={handleSelectedRowsChange}
                    selectedRows={selectedRows}
                    selection={
                      !actionEditState &&
                      !actionAddState &&
                      userPermissions.includes(deletePermission)
                    }
                    setConfirmModalOpen={setOpenModalDelete}
                  />
                </div>
              </div>
            </div>
            <ConfirmBoxModal
              ModalTitle="Update Office Department"
              qConfirmation=" Are you sure you want to update this?"
              isOpen={openModalEdit}
              onClose={() => {
                setOpenModalEdit(false);
                setIsSaving(false);
              }}
              onClickFunction={() => {
                handleSave(newData);
                setIsSaving(false);
              }}
              cancelButtonRef={undefined}
            />
            <ConfirmBoxDelete
              ModalTitle="Deactivate Office Department"
              qConfirmation={deleteMessage}
              isOpen={openModalDelete}
              onClose={() => {
                setOpenModalDelete(false);
              }}
              onClickFunction={handleDelete}
              cancelButtonRef={undefined}
            />
          </div>
        )}
        {actionAddState && (
          <div className="">
            <OfficeDepartmentForm
              isAdd={actionAddState}
              setIsAdd={setActionAddState}
            />
          </div>
        )}
      </div>
    </div>
  );
};
export default OfficeDepartmentTable;
